'use client';
import Image from 'next/image';
import React from 'react';
import { useRouter } from 'next/navigation';
import InputSearch from '@/components/input-search/input-search';
import { IoIosArrowDown } from 'react-icons/io';
import { categoriesData, dataCountry, styleMovie, years } from '@/data/constants';

const Header = () => {
  const [isRedirect, setIsRedirect] = React.useState<boolean>(true);
  const router = useRouter();
  const redirectHome = () => {
    router.push('/');
  };

  const handleClick = () => {
    if (isRedirect) {
      setIsRedirect(false);
      window.open(
        'https://www.profitableratecpm.com/jq5yf4utj7?key=aa3848ff8ca415aeec065877a1e5d169',
        '_blank',
      );
    }
  };

  return (
    <div className="w-full h-16 bg-colorMain flex justify-center">
      <div className="w-[1400px] max-xl:w-full h-full flex items-center justify-between">
        <div className="flex gap-x-4 items-center">
          <a href="/">
            <Image
              alt=""
              unoptimized={true}
              quality={100}
              src={'/images/icon.png'}
              width={134}
              height={33}
              className="h-[33px] cursor-pointer object-cover"
              onClick={redirectHome}
            />
          </a>

          <div className="flex relative items-center gap-x-4 cursor-pointer text-[12px] font-medium hover:text-yellowMain max-lg:hidden">
            {/* {isRedirect && (
              <div
                className="absolute top-0 w-full h-full left-0 opacity-0 bottom-0 right-0"
                onClick={handleClick}
              ></div>
            )} */}

            {styleMovie.map((val, i) => {
              return (
                <a
                  key={val.slug}
                  onClick={handleClick}
                  href={`/danh-sach/${val.slug}`}
                  className="text-white uppercase hover:text-yellowMain"
                >
                  {val.title}
                </a>
              );
            })}
            <div className="text-white uppercase flex items-center gap-x-[2px] hover:text-yellowMain group relative">
              <div
                onClick={() => {
                  handleClick();
                  router.push('/the-loai');
                }}
              >
                Thể loại
              </div>
              <IoIosArrowDown size={18} className="hover:text-yellowMain" />
              <div
                className="absolute scroll-container z-30 top-full left-0 mt-2 w-[500px] bg-white shadow-md overflow-hidden grid grid-cols-3 gap-x-2
                text-[12px] max-h-0 group-hover:max-h-[200px] overflow-y-scroll transition-[max-height] duration-300 ease-in-out group-hover:border-t-[3px] border-solid group-hover:border-yellowMain"
              >
                {categoriesData.map((values, index) => {
                  return (
                    <a
                      key={index}
                      onClick={handleClick}
                      href={`/the-loai/${values.slug}`}
                      className="block px-4 py-2 text-gray-700 hover:bg-gray-100 line-clamp-1"
                    >
                      {values.title}
                    </a>
                  );
                })}
              </div>
            </div>
            <div className="text-white uppercase flex items-center gap-x-[2px] hover:text-yellowMain group relative">
              <div>Quốc gia</div>
              <IoIosArrowDown size={18} className="hover:text-yellowMain" />
              <div
                className="absolute scroll-container z-30 top-full left-0 mt-2 w-[400px] bg-white shadow-md overflow-hidden grid grid-cols-3 gap-x-2
                text-[12px] max-h-0 group-hover:max-h-[200px] overflow-y-scroll transition-[max-height] duration-300 ease-in-out group-hover:border-t-[3px] border-solid group-hover:border-yellowMain"
              >
                {dataCountry.map((values) => {
                  return (
                    <a
                      key={values.slug}
                      onClick={handleClick}
                      href={`/quoc-gia/${values.slug}`}
                      className="block px-4 py-2 text-gray-700 hover:bg-gray-100 line-clamp-1"
                    >
                      {values.title}
                    </a>
                  );
                })}
              </div>
            </div>
            <div className="text-white uppercase flex items-center gap-x-[2px] hover:text-yellowMain group relative">
              <div>Năm</div>
              <IoIosArrowDown size={18} className="hover:text-yellowMain" />
              <div
                className="absolute scroll-container z-30 top-full left-0 mt-2 w-[360px] bg-white shadow-md overflow-hidden grid grid-cols-3 gap-x-2
                text-[12px] max-h-0 group-hover:max-h-[200px] overflow-y-scroll transition-[max-height] duration-300 ease-in-out group-hover:border-t-[3px] border-solid group-hover:border-yellowMain"
              >
                {years.map((values) => {
                  return (
                    <a
                      key={values}
                      onClick={handleClick}
                      href={`/nam/${values}`}
                      className="block px-4 py-2 text-gray-700 hover:bg-gray-100 line-clamp-1"
                    >
                      {values}
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <InputSearch />
      </div>
    </div>
  );
};

export default Header;
